import { applyMiddleware, combineReducers, compose,createStore,} from 'redux';
import thunk from 'redux-thunk';
import { AuthReducer } from './reducers/AuthReducer';
import ProfileReducer from './reducers/ProfileReducer';
import AccessKeyReducer from './reducers/AccessKeyReducer';
import TransactionSettingReducer from './reducers/TransactionSettingReducer';
import KYCSettingReducer from "./reducers/KYCSettingReducer";
import MerchantReducer from "./reducers/MerchantReducer";
import MerchantTransSettingsReducer from "./reducers/MerchantTransSettingsReducer";
import MerchantBankAccountsReducer from "./reducers/MerchantBankAccountsReducer";
import MerchantKycReducer from "./reducers/MerchantKycReducer";
import IPAddressReducer from "./reducers/IPAddressReducer";
import MerchantFundRequestReducer from "./reducers/MerchantFundRequestReducer";
import MerchantBalanceReducer from "./reducers/MerchantBalanceReducer";
import MerchantPayoutReducer from "./reducers/MerchantPayoutReducer";
import MerchantReportReducer from "./reducers/MerchantReportReducer";
import MerchantTransactionComplaints from "./reducers/ComplaintsReducer";
const middleware = applyMiddleware(thunk);
const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const reducers = combineReducers({
    auth: AuthReducer,
    profile: ProfileReducer,
    accessKey: AccessKeyReducer,
    transactionSettings: TransactionSettingReducer,
    kycSettings: KYCSettingReducer,
    merchants:MerchantReducer,
    merchantBanks:MerchantBankAccountsReducer,
    merchantTransSettings:MerchantTransSettingsReducer,
    merchantKyc:MerchantKycReducer,
    IPAddress:IPAddressReducer,
    fundRequests:MerchantFundRequestReducer,
    merchantBalance : MerchantBalanceReducer,
    merchantReports : MerchantReportReducer,
    merchantPayout : MerchantPayoutReducer,
    merchantTransactionComplaints : MerchantTransactionComplaints
})  
export const store = createStore(reducers,  composeEnhancers(middleware));
